<mat-card style="min-height: 500px">
    <mat-card-content>
        <div class="max-width">
            <div class="mb-2">
                <button class="btn btn-success btn-sm" (click)="onExportReport()">Export Report to Excel</button>
            </div>
            <div class="form-group row mb-2" [formGroup]="paramForm">
                <div class="col-md-2">
                    <app-select-academic-year-only
                        (academicYearChanged)="onChangeAcademicYear($event)">
                    </app-select-academic-year-only>
                </div>
                <div class="col-md-2">
                    <app-select-school-level-relation-v2
                        [academic_year]="this.paramForm.get('academic_year')?.value"
                        (schoolLevelRelationChanged)="onChangeSchoolLevel($event)"
                        [isDisabled]="!this.paramForm.get('academic_year')?.value">
                    </app-select-school-level-relation-v2>
                </div>
                <div class="col-md-2">
                    <app-select-school-program
                        [academic_year]="this.paramForm.get('academic_year')?.value"
                        [school_location_id]="this.paramForm.get('school_location_id')?.value"
                        [isDisabled]="!this.paramForm.get('school_location_id')?.value"
                        (schoolProgramChanged)="onChangeSchoolProgram($event)">
                    </app-select-school-program>
                </div>
                <div class="col-md-2">
                    <ng-select
                        [items]="yearLevelRelations"
                        (change)="onChangeYearLevel($event)"
                        bindLabel="description"
                        bindValue="year_level_id"
                        formControlName="year_level_id"
                        placeholder="Select year level"
                        class="selector-style">
                        <ng-template ng-option-tmp let-item="item">
                            <div class="custom-option-style">
                                {{ item.description }}
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
            </div>
            <div class="d-flex mb-3">
                <div class="me-2">
                    <label class="switch">
                        <input type="checkbox" formControlName="rule_based" (change)="onRuleBasedChange()">
                        <span class="slider round"></span>
                    </label>
                </div>
                <div>
                    {{ 'Include Non-maxed Activity Selection' }}
                </div>
            </div>
            <table mat-table
                [dataSource]="reportData" multiTemplateDataRows
                >

                <ng-container matColumnDef="student_name">
                    <th mat-header-cell *matHeaderCellDef class="cursor-pointer"> {{ 'STUDENT_NAME' | translate }} </th>
                    <td mat-cell *matCellDef="let element" class="example-element-position">
                        {{element.student_name || '-'}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="nis">
                    <th mat-header-cell *matHeaderCellDef class="cursor-pointer"> {{ 'NIS' | translate }} </th>
                    <td mat-cell *matCellDef="let element" class="example-element-position">
                        {{element.nis || '-'}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="class_name">
                    <th mat-header-cell *matHeaderCellDef class="cursor-pointer"> {{ 'CLASS_NAME' | translate }} </th>
                    <td mat-cell *matCellDef="let element" class="example-element-position">
                        {{element.class_name || '-'}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="total_participated">
                    <th mat-header-cell *matHeaderCellDef class="cursor-pointer"> {{ 'TOTAL_PARTICIPATED' | translate }} </th>
                    <td mat-cell *matCellDef="let element" class="example-element-position">
                        {{element.total_participated}}
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
                <tr mat-row *matRowDef="let element; let i = index; columns: columnsToDisplay;" class="example-element-row"></tr>

                <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell p-2" [attr.colspan]="reportData.length" *ngIf="!loading">
                        No report data
                    </td>
                </tr>
            </table>
        </div>
    </mat-card-content>
</mat-card>
